import './defaultPropsPolyfill'

import { configure } from '@tabeo/sharpei/config'
import '@tabeo/sharpei/polyfills'
import config from 'config'
import 'lib/zod'
import 'moment/locale/en-gb'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './assets/tailwind.css'

configure(config)

// Force HTTPS
if (
  window.location.protocol !== 'https:' &&
  ['development', 'demo', 'production'].includes(config.env)
) {
  window.location.href = `https:${window.location.href.substring(
    window.location.protocol.length
  )}`
}

createRoot(document.getElementById('root')).render(React.createElement(App))
